import DelayedTask from "@/server/com/silkplm/rpc/dto/DelayedTask";
import EventBus from "@/utils/EventBus";
import ServerEvents from "@/server/ServerEvents";
import RoutingKeys from "@/server/RoutingKeys";

let listInstance = null;
export function registerListInstance(instance){
    listInstance = instance;
}

class _DelayedTaskManager{
    constructor() {
        this.watchedSequenceIDs = new Map();
        this.tasks = [];
        EventBus.$on(ServerEvents.progressInfo, async progressInfo => {
            if(progressInfo.partialResults && progressInfo.taskId){
                for(let i in this.tasks) {
                    let task = this.tasks[i];
                    if (task.taskId === progressInfo.taskId) {
                        if(task.onPartialResultCallback){
                            try {
                                task.onPartialResultCallback(progressInfo.partialResults);
                            } catch (e){
                                console.error(e);
                            }
                        }
                        break;
                    }
                }
            }
        });

        EventBus.$on(ServerEvents.delayedTaskComplete, async taskResult => {
            for(let i in this.tasks){
                let task = this.tasks[i];
                if(task.taskId === taskResult.taskId){
                    if(taskResult.hasErrors){
                        task.error = "Error";
                        task.errorDetails = taskResult.error;
                        if(task.reject){
                            task.reject(taskResult.error);
                        }
                    } else {
                        if (task.type === "download") {
                            task.link = taskResult.result.url;
                        }
                        if(task.resolve){
                            task.resolve(taskResult.result);
                        }
                    }
                    task.__resolved = true;
                    task.__result = taskResult;
                    this.tasks.splice(i, 1);

                    break;
                }
            }
        });
    }

    /**
     * @param delayedTask
     */

    captureDelayedTask(delayedTask){
        if(delayedTask instanceof DelayedTask) {
            // console.log("Task capture delayed start with ID: ", delayedTask.taskId);
            if(delayedTask.type !== "silent") {
                listInstance?.captureDelayedTask(delayedTask);
            }
            this.tasks.push(delayedTask);

            let finishPromise = new Promise((resolve, reject) => {
                delayedTask.resolve = resolve;
                delayedTask.reject = reject;

                if(delayedTask.__resolved){
                    setTimeout(() => {
                        if(delayedTask.__result.hasErrors){
                            reject(delayedTask.__result.error);
                        } else {
                            resolve(delayedTask.__result);
                        }
                    })
                }
            });

            delayedTask.finish = function(){
                return finishPromise;
            }

            delayedTask.promise = finishPromise;
            //delayedTask.then = finishPromise.then.bind(finishPromise);
            //delayedTask.catch = finishPromise.catch.bind(finishPromise);
            //delayedTask.finally = finishPromise.finally.bind(finishPromise);
            delayedTask.onPartialResultCallback = null;

            delayedTask.onPartialResult = function (callback){
                delayedTask.onPartialResultCallback = callback;
            }

            return delayedTask;
        } else {
            return delayedTask;
        }
    }
}
let DelayedTaskManager = new _DelayedTaskManager();
export default DelayedTaskManager;
if(window){
    window['DelayedTaskManager'] = DelayedTaskManager;
}
